//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.SelectCollisionSensorList.js";
import "../Mechatronics/Mechatronics.SelectSignalList.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CollisionSensor",0,"Mechatronics.SelectCollisionSensorList",0],[0,"DeleteSource",1,0],[0,"Name",1,0],[0,"SignalDeleteSource",1,0],[1,"SignalObject",0,"Mechatronics.SelectSignalList",0],[0,"SinkBond",1,0],[1,"Source",0,"SelectNXObjectList",0],[0,"TriggerOption",1,0]],[[["objects"],"SetCollisionSensor",{},1,0],[["objects"],"SetSignalobject",{},1,0],[["objects"],"SetSource",{},1,0]],[]];
SPLM.Mechatronics.ObjectSinkBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ObjectSinkBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ObjectSinkBuilder.DeleteSourceType = Object.freeze({
    "Anycopiedobjects" : "Anycopiedobjects", "Selectedsources" : "Selectedsources"});

SPLM.Mechatronics.ObjectSinkBuilder.TriggerOptions = Object.freeze({
    "Triggerbycollision" : "Triggerbycollision", "Triggerbysignal" : "Triggerbysignal"});

SPLM.Mechatronics.ObjectSinkBuilder.SignalSinkSourceType = Object.freeze({
    "Allcopiedobjects" : "Allcopiedobjects", "Selectedsources" : "Selectedsources"});

export default SPLM;